import Post from 'types/Post';
import { IGenericResponse } from 'state/interfaces';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const rentApi = createApi({
  reducerPath: 'rentApi',
  baseQuery: fetchBaseQuery({ baseUrl: `${process.env.REACT_APP_SERVER_ENDPOINT}/rent`, credentials: "include" }),
  endpoints: (builder) => ({
    subscribeProduct: builder.mutation<string, string>({
      query: id => ({
        url: `/${id}/subscribe`,
        method: `POST`
      }),
      transformResponse: (results: IGenericResponse<string>) => results.data,
    }),
    checkSubscription: builder.query<string, string>({
      query: id => ({
        url: `/${id}/check`
      }),
      transformResponse: (results: IGenericResponse<string>) => results.data,
    }),
    unsubscribeProduct: builder.query<string, string>({
      query: id => ({
        url: `/${id}/unsubscribe`
      }),
      transformResponse: (results: IGenericResponse<string>) => results.data,
    }),
  }),
});

export const {
    useSubscribeProductMutation,
    useCheckSubscriptionQuery,
    useUnsubscribeProductQuery
} = rentApi;